import { __rest } from "tslib";
import React from 'react';
import { path } from 'ramda';
import { Controller, useFormContext } from 'react-hook-form';
const FieldController = (_a) => {
    var { name, as, render, isNotRender } = _a, props = __rest(_a, ["name", "as", "render", "isNotRender"]);
    const { formState: { touched, isSubmitted }, defaultValues = {}, errors, } = useFormContext();
    const shouldDisableValidation = !touched[name] && !defaultValues[name] && !isSubmitted && !errors[name];
    const additionalProps = {
        shouldDisableValidation,
        error: path([name, 'message'], errors),
    };
    const modifiedAs = as && React.cloneElement(as, additionalProps);
    const modifiedRender = render
        ? (_a) => {
            var { ref } = _a, innerProps = __rest(_a, ["ref"]);
            return render(Object.assign(Object.assign({}, innerProps), additionalProps));
        }
        : undefined;
    return !isNotRender ? (React.createElement(Controller, Object.assign({}, props, { name: name, as: modifiedAs, render: modifiedRender }))) : (React.createElement(React.Fragment, null));
};
export default FieldController;
//# sourceMappingURL=FieldController.js.map